<template>
	<div class="news-single header--padding" v-if="news">

		<div class="news-single__header panel panel--lightest-grey">
			<div class="news-single__centraliser news-single__centraliser--medium">

				<router-link v-if="category" :to="{ name: 'NewsArchive', params: {category: news.category}}" class="news-single__category">{{category}}</router-link>
				<h1 class="news-single__title">{{news.title}}</h1>
				<div  v-if="news.date" class="news-single__meta">
					<span v-if="news.date" class="news-single__date">
						{{news.date | formatDate}}
					</span>
				</div>

			</div>
		</div>


		<div class="news-single__body panel">
			<div v-if="(!news.content || news.content.length == 0 || news.content[0].type !== 'video') && news.imageHero && news.imageHero.link" class="news-single__hero-wrap">
				<div class="news-single__centraliser news-single__centraliser--wide">
					<img class="news-single__hero" :src="news.imageHero.link" />
				</div>
			</div>

			<template v-for="(item, index) in news.content">

				<!-- TEXT -->
				<div v-if="item.type === 'text'" class="news-single__module news-single__module--text tag--styled" :class="{
					'news-single__module--first' : index == 0,
				}" :key="index">
					<div class="news-single__centraliser" v-html="item.content"></div>
				</div>

				<!-- IMAGE -->
				<div v-else-if="item.type === 'image' && item.image && item.image.link" class="news-single__module news-single__module--image" :class="{
					'news-single__module--first' : index == 0,
				}" :key="index">
					<div class="news-single__centraliser">
						<img :src="item.image.link" :alt="item.image.metadata" />
					</div>
				</div>

				<!-- VIDEO -->
				<div v-else-if="item.type === 'video'" class="news-single__module news-single__module--video" :class="{
					'news-single__module--first' : index == 0,
				}" :key="index">
					<div class="news-single__centraliser" :class="{
						'news-single__centraliser--wide' : index == 0,
					}">
						<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
							<div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
								<iframe v-bind:src="'//fast.wistia.net/embed/iframe/'+item.video" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen style="height:100%;width:100%"></iframe>
								<!--<div v-bind:class="'seo=false videoFoam=true wistia_embed wistia_async_'+item.video" style="height:100%;width:100%">&nbsp;</div>-->
							</div>
						</div>
					</div>
				</div>

				<!-- BLOCKQUOTE -->
				<div v-else-if="item.type === 'blockquote'" class="news-single__module news-single__module--blockquote" :class="{
					'news-single__module--first' : index == 0,
				}" :key="index">
					<div class="news-single__centraliser news-single__centraliser--medium" v-html="item.blockquote"></div>
				</div>

				<!-- BUTTON / LINK -->
				<div v-else-if="item.type === 'link'" class="news-single__module news-single__module--link" :class="{
					'news-single__module--first' : index == 0,
				}" :key="index">
					<div class="news-single__centraliser">
						<Btn :tab="item.tab" :link="item.link"><span v-html="item.title"></span></Btn>
					</div>
				</div>

				<!-- DOWNLOAD -->
				<div v-else-if="item.type === 'download' && item.download && item.download.link" class="news-single__module news-single__module--download" :class="{
					'news-single__module--first' : index == 0,
				}" :key="index">
					<div class="news-single__centraliser">
						<div class="news-single__download">
							<h2 v-if="item.title" class="h3 news-single__download-title" v-html="item.title"></h2>
							<Btn class="h3 news-single__download-link" :link="item.download.link"><span>Download Now</span></Btn>
						</div>
					</div>
				</div>

			</template>


			<div class="news-single__share">
				<div class="news-single__centraliser news-single__centraliser--wide">

					<a href="mailto:ilotteryshowcaseinquiry@igt.com?subject=IGT Lottery Showcase - Request Account" class="btn" style="background-color:#5FB743; margin-bottom: 25px;">SIGN UP NOW</a>
					
					<h2 class="h3 news-single__download-title">Share this article</h2>
					<social-sharing :title="news.title" :description="news.synopsis" v-bind:url="postUrl" inline-template>

						<div class="grid grid--b16 grid--auto grid--middle grid--center">
							<div class="grid__item">
								<network network="facebook">
									<div class="btn btn--style--custom news-single__share-btn news-single__share-btn--facebook">
										<span class="news-single__share-icon fonticon fonticon--facebook--circle"></span>
										<span>Facebook</span>
									</div>
								</network>
							</div>
							<div class="grid__item">
								<network network="twitter">
									<div class="btn btn--style--custom news-single__share-btn news-single__share-btn--twitter">
										<span class="news-single__share-icon fonticon fonticon--twitter--circle"></span>
										<span>Twitter</span>
									</div>
								</network>
							</div>
							<div class="grid__item">
								<network network="linkedin">
									<div class="btn btn--style--custom news-single__share-btn news-single__share-btn--linked-in">
										<span class="news-single__share-icon fonticon fonticon--linked-in--circle"></span>
										<span>LinkedIn</span>
									</div>
								</network>
							</div>
						</div>

					</social-sharing>

				</div>
			</div>

		</div>

		<div class="panel panel--lightest-grey" v-if="relatedNews.length > 0">
			<div class="page-container">

				<div class="panel__title">
					<div class="grid grid--bottom grid--auto grid--spread-between">
						<div class="grid__item">
							<h2 class="h3 heading--black">Read next</h2>
							<h3 class="h4 fc-pal--grey">You may be interested in...</h3>
							<h2 class="h3"></h2>
						</div>
						<mq-layout :mq="['ltab', 'desk']" class="grid__item">
							<router-link class="btn btn--style--stroke" :to="{ name: 'NewsArchive' }">
								<span>Go Back</span>
							</router-link>
						</mq-layout>
					</div>
				</div>

				<div class="grid">
					<div class="grid__item one-third--not-phab one-half--phab" v-for="(item, index) in relatedNews" :key="index">
						<news-overview :news="item" :showSummary="false" v-scroll-to="{
							element: $el
						}"></news-overview>
					</div>
				</div>

			</div>
		</div>
		
		<div class="modal" v-if="showEventModal" @click="showEventModal = false">
			<div class="modal-wrapper">
				<div class="modal-dialog" @click.stop="">
					<div class="modal-content">
					<span class="close_modal fonticon fonticon--close" @click="showEventModal = false"></span>
						<img src="@/assets/img/news/popup_logo.png" alt="IGT logo" class="news-popup__logo">
						<div class="modal-body">
							<h2 class="h4 fc-pal--grey">There's a lot more to see on the <br/><span>IGT iLottery Showcase.</span><br/> Play our entire eInstant library and more!</h2>
							<h3 class="h4 fc-pal--grey">Just sign up with your Lottery email.</h3>
							<div class="button_wrapper">
							<a href="mailto:ilotteryshowcaseinquiry@igt.com?subject=IGT%20Lottery%20Showcase%20-%20Request%20Account" target="_blank" class="btn btn-green"><span>Sign Up Now</span> </a>
							<span class="separate">OR</span>
							<a href="/login" target="_blank" class="btn-default"><span>Login</span> </a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import { filter, sortBy } from 'lodash'
import Btn from './atoms/Btn'
import NewsOverview from './molecules/NewsOverview'

export default {
	name: 'NewsSingle',
	components: {
		Btn,
		NewsOverview,
	},
	data () {
		return {
			news: null,
			allNews: [],
			showEventModal: false
		}
	},
	computed: {
		inputListeners: function () {
			var vm = this;
			// `Object.assign` merges objects together to form a new object
			return Object.assign({},
				// We add all the listeners from the parent
				this.$listeners,
				// Then we can add custom listeners or override the
				// behavior of some listeners.
				{
					// This ensures that the component works with v-model
					input: function (event) {
						vm.$emit('input', event.target.value)
					}
				}
			)
		},
		postUrl() {
			if (this.news === null) return '';

			return `https://www.igtilottery.com/news-events/post/${this.$route.params.id}`
		},
		category()
		{
			return this.$store.state.app.categories[this.news.category];
		},
		relatedNews()
		{
			var result = [];
			var today = new Date();

			// Filter all posts that match the current post's category
			var relatedNews = filter(this.allNews, (item) =>
			{
				var date1 = new Date(item.date);
				return item.status && date1 <= today && item.id != this.news.id && (!this.news.category || this.news.category == "" || item.category == this.news.category);
			});
			relatedNews = sortBy(relatedNews, ["date"]).reverse();

			result = relatedNews.slice(0, 3);

			// If we have less than 3, back fill with the latest posts
			if(result.length < 3 && this.allNews.length - 1 > result.length)
			{
				var len = result.length;
				var relatedNews = filter(this.allNews, (item) =>
				{
					var date1 = new Date(item.date);
					return item.status && date1 <= today && item.id != this.news.id;
				});
				relatedNews = sortBy(relatedNews, ["date"]).reverse();

				result = result.concat(relatedNews.slice(0, 3-len));
			}

			return result;
		}
	},
	created: function()
	{
		if(this.$route.params.hasOwnProperty('id'))
		{
			this.getNewsPost(this.$route.params.id);
		}

		this.getNewsPosts();
	},
	watch: {
		news() {
			var self = this;
			var l = 0;

			self.news.content.map(obj =>{
				if (obj.type == "video" && l == 0) {
					let scriptOne = document.createElement('script');
					scriptOne.setAttribute('src', '//fast.wistia.com/embed/medias/'+obj.video+'.jsonp');
					document.head.appendChild(scriptOne);

					let scriptTwo = document.createElement('script');
					scriptTwo.setAttribute('src', '//fast.wistia.com/assets/external/E-v1.js');
					document.head.appendChild(scriptTwo);

					l++;
				}
			});

		},
  	'$root.userSelectedRegionKey': function()
  	{
			this.$root.appImmediateLoading = true;

	   	this.getNewsPosts()
      .then(success =>
      {
				this.$root.appImmediateLoading = false;
      });
  	},
  	'$route.params.id': function()
  	{
			this.getNewsPost(this.$route.params.id);
  	}
	},
	methods: {
		getNewsPost(id)
		{
   		var self = this;

			// Get specific news posts
			return self.$api.getNews(id).then((data) => {
				if(data.hasOwnProperty('data')) {
					self.news = data.data.results
				}
				self.$root.$data.appLoading = false;
			}).catch((error) => {
				self.$alert.danger({ message: error.message });
			});
		},
		getNewsPosts()
		{
   		var self = this;

			// Get all news posts
			var regions = this.$root.userSelectedRegion ? [this.$root.userSelectedRegion.key] : null;
			return self.$api.getNews(null, null, null, null, null, regions).then((data) => {
				if(data.hasOwnProperty('data')) {
					self.allNews = data.data.results
				}
				self.$root.$data.appLoading = false;
				console.log(data.data.show_newspopup);
				this.showEventModal = self.$root.$data.user === null && data.data.show_newspopup
			}).catch((error) => {
				self.$alert.danger({ message: error.message });
			});
		},
	}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".news-single";
	#{$c}
	{
		&__centraliser
		{
			@include extend(page-container);
			max-width: 584px + (2 * $page-padding);

			&--medium
			{
				max-width: 793px + (2 * $page-padding);
			}

			&--wide
			{
				max-width: 1000px + (2 * $page-padding);
			}
		}

		&__header
		{
			text-align: center;
			padding-bottom: rem(64);
		}

		&__category
		{
			display: inline-block;
			@include extend(h6);
			color: palette(link);
			margin-bottom: rem(24);
		}

		&__title
		{
			@include extend(h1);
			margin-bottom: rem(48);
		}

		&__meta
		{
			margin-bottom: rem(16);
		}

		&__date
		{
			display: inline-block;
			color: palette(light-grey);
		}

		&__hero-wrap,
		&__module--video#{$c}__module--first
		{
			text-align: center;
			margin-top: rem(-25);
			margin-bottom: rem(80);
			position: relative;
			z-index: 0;

			@include media(not-phab)
			{
				margin-top: rem(-64);
			}

			&:before
			{
				content: '';
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 50%;
				background-color: palette('lightest-grey');
				z-index: -1;
			}
		}

		&__module
		{
			margin-bottom: rem(32);

			&--text
			{
				font-size: rem(20);
				line-height: (28/20);
				color: palette(grey);

				h1, h2, h3, h4, h5, h6
				{
					color: palette(font);
					@include extend(heading--black);

					&:not(:first-child) { margin-top: 0.75em; }
					&:not(:last-child) { margin-bottom: 0.75em; }
					&:last-child { margin-bottom: rem(-8); }
				}

				h1, h2
				{
					@include extend(h3-size);
				}
				h3 { @include extend(h4-size); }
				h4 { @include extend(h5-size); }
				h5, h6 { @include extend(h6-size); }
			}

			&--image,
			&--video,
			&--link
			{
				text-align: center;
			}

			&--blockquote
			{
				text-align: center;
				@include extend(h2);

				&:not(:first-child) { margin-top: rem(72); }
			}

			&--download
			{
				margin-bottom: rem(40);
			}
		}

		&__download
		{
			background-color: palette('lightest-grey');
			padding: rem(40) rem(16);
			text-align: center;

			@include media(not-phab) { padding: rem(80) rem(24); }

			&-title
			{
				max-width: 432px;
				@include extend(block-center);
				margin-bottom: rem(24);

				@include media(not-phab) { margin-bottom: rem(40); }
			}
		}

		&__share
		{
			text-align: center;
			margin-top: rem(88);

			&-btn
			{
				padding-left: rem(20);
				padding-right: rem(24);
				color: palette('white');

				&--facebook { background-color: #4460A0; }
				&--twitter { background-color: #00AAEC; }
				&--linked-in { background-color: #007EBB; }
			}

			&-icon
			{
				font-size: rem(20);
			}
		}
	}
	.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}
	.modal-wrapper{
		width: 35%;
	}
	.modal-dialog{
		text-align: center;
	}
	.modal-content {
		background-color: #fff;
		padding: 50px 30px 30px;
		border-radius: 5px;
		position: relative;
	}
	.close_modal{
		position: absolute;
		right: 20px;
		top: 20px;
		cursor: pointer;
	}
	.modal-body h2{
		margin-top: 40px;
		margin-bottom: 50px;
		color: #666;
		font-size: 2rem;
		line-height: 40px;
	}
	.modal-body h2 span{
		font-weight: 600;
	}
	.button_wrapper{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		row-gap: 20px;
		margin: 40px 0px 20px;
	}
	.btn-green{
		background-color: #5FB743!important;
		font-weight: 500;
		font-size: 16px!important;
	}
	.btn-default{
		color: #666666;
		font-size: 1rem;
		text-decoration: underline;
		text-transform: uppercase;
		font-weight: 600;
	}
	.separate{
		color: #B3B3B3;
		font-size: 0.875rem;
	}
	.news-popup__logo {
		width: 9rem;
		height: auto;
	}
	@media(max-width: 767px){
		.modal-wrapper {
			width: 95%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/NewsSingle.vue